import { connect } from "react-redux";
import React from 'react';
import {FooterConfiguration} from "./FooterConfiguration";
const FooterContainer=(props)=>{
    let map=FooterConfiguration(props,props?.customerId);
    return(
        map
    );
}
const mapStateToProps = (state) => {
    return {
    customerId:state.login.customerId,
      
    };
  };
  const mapDispatchToProps = {
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(FooterContainer);